import React from 'react';
import { DonutChart } from '../ChartComponents/DonutChart';

interface PortfolioItem {
    label: string;
    value: number;
    color: string;
}

interface ClientPortfolioWidgetProps {
    data: PortfolioItem[];
    centerLabel?: string;
    centerValue?: string;
}

export const ClientPortfolioWidget: React.FC<ClientPortfolioWidgetProps> = ({
    data,
    centerLabel = "Total",
    centerValue = "100"
}) => {
    return (
        <div className="bg-white portal-content-shadow rounded-lg shadow-sm border border-gray-200 p-6 h-full">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Client Portfolio</h3>
            <div className="flex justify-center">
                <DonutChart
                    data={data}
                    centerLabel={centerLabel}
                    centerValue={centerValue}
                    size={200}
                />
            </div>
        </div>
    );
};
